(function () {
    function CustomSelectController(
        $scope) {

        var self = this;

        $scope.selectedItem = undefined;
        $scope.options = undefined;
        $scope.showOptions = false;

        // $doCheck is a hook into the angular life-cycle. It's invoked
        //  whenever a digest cycle happens and should be used to detect
        //  changes that angular's change detector would not pick up
        // inside this function, `this` looks like the instance of the controller,
        // provided by angular
        this.$doCheck = function() {
            $scope.options = self.selectOptions;
            $scope.selectedItem = _.find($scope.options, function(option) {
                return option.Id === self.selectModel;
            });
        }

        $scope.optionSelected = function(selectedItem) {
            $scope.selectedItem = selectedItem;
            $scope.$ctrl.selectModel = selectedItem.Id;
            $scope.showOptions = false;
        }

        $scope.toggleOptions = function() {
            $scope.showOptions = !$scope.showOptions;
        }
    }

    angular
        .module('dashboard')
        .component('customSelect',
            {
                templateUrl: 'components/customselect/customselect.0087696e.html',
                bindings: {
                    selectModel: "=",
                    selectOptions: "<"
                },
                controller: [
                    '$scope',
                    CustomSelectController ]
            });
})();
